import styled from '@emotion/styled';
import { useEffect } from 'react';
import { EmptyList } from 'ui-components/common/EmptyList';
import { InfiniteScrollWrapper } from 'ui-components/common/InfiniteScrollWrapper';
import { ContentBodyContainer } from 'ui-components/layout/containers/ContentBodyCenterContainer';
import { Loading } from 'ui-components/common/Loading';
import { useRollingDispatchState, useRollingState } from 'contexts/RollingProvider';
import { useTrackingState } from 'contexts/TrackingProvider';
import { TrackerExtraInfo, TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { RollingItem } from 'app-components/rolling/RollingItem';

interface RollingListProps {
  trackerExtraInfo: TrackerExtraInfo;
  emptyDescription?: string;
}

export const RollingList = ({ trackerExtraInfo, emptyDescription = '남겨진 롤링이 없어요' }: RollingListProps) => {
  const { isPending, hasNextPage, fetchNextPage, rollings, profiles } = useRollingState();

  const { dispatchAction } = useRollingDispatchState();

  const { tracker } = useTrackingState();
  useEffect(() => {
    tracker.track(TrackingEventType.ViewRollingList, { trackerExtraInfo });
  }, [tracker, trackerExtraInfo]);

  return (
    <InfiniteScrollWrapper hasNext={hasNextPage} loadMore={fetchNextPage}>
      <ContentBodyContainer>
        {!isPending && rollings.length === 0 && <EmptyList description={emptyDescription} />}
        <StyledList>
          {rollings.map(rolling => {
            const profile = profiles[rolling.profileId];

            if (!profile) {
              return null;
            }

            return (
              <StyledRollingItem
                key={rolling.id}
                rolling={rolling}
                profile={profile}
                showMoreMenu
                showDescLines={3}
                onDispatchAction={dispatchAction}
                trackerExtraInfo={trackerExtraInfo}
              />
            );
          })}
          {isPending && <Loading />}
        </StyledList>
      </ContentBodyContainer>
    </InfiniteScrollWrapper>
  );
};

const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 100px;
  gap: 8px;
  min-height: 300px;
`;

const StyledRollingItem = styled(RollingItem)`
  width: 100%;
  height: 163px;
`;
